export default class SvgController {
    constructor(element) {
        this.overlay = [];
        this.svg = element;
        this.svgPath = element.querySelector('path');
    }

    getSvgPoint(percentage) {
        return this.svgPath.getPointAtLength((this.svgPath.getTotalLength() * percentage) / 100);
    }

    getDOMPointCoordinates(svgPoint) {
        const domPoint = svgPoint.matrixTransform(this.svg.getScreenCTM());

        return {
            left: `${domPoint.x}px`,
            top: `${domPoint.y}px`,
        };
    }

    setOverlay(el, percentage = 0) {
        this.overlay.push({ el, percentage });
    }

    positionOverlays() {
        this.overlay.forEach((overlay) => {
            const overlayItem = overlay;
            const svgPoint = this.getSvgPoint(overlayItem.percentage);
            const coordinates = this.getDOMPointCoordinates(svgPoint);
            overlayItem.el.style.left = coordinates.left;
            overlayItem.el.style.top = coordinates.top;
        });
    }
}
